import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

type IProps = {
  text: string;
  Icon: any;
  show?: boolean;
  to: string;
};

const MenuLink: React.FC<IProps> = ({ text, Icon, to, show = true }) => {
  const navigate = useNavigate();
  return (
    <>
      {show && (
        <ListItem key={text} disablePadding onClick={() => navigate(to)}>
          <ListItemButton>
            <ListItemIcon>{Icon}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItemButton>
        </ListItem>
      )}
    </>
  );
};

export default MenuLink;
